// ============================================================
// Channel Statistics — Static fallback data
// Replace the `count` values by connecting to the relevant APIs:
//   - Twitch: https://api.twitch.tv/helix/channels/followers
//   - Instagram: Instagram Basic Display API
//   - TikTok: TikTok Research API / unofficial scraper
// ============================================================

export interface ChannelStat {
  /** Unique key used as i18n lookup: stream.stats.{id}.label */
  id: string;
  platform: string;
  handle: string;
  url: string;
  icon: string;
  /** Raw follower / subscriber count */
  count: number;
  /** Whether the count is live / updated automatically */
  isLive: boolean;
  /** Accent color class for this platform */
  color: string;
  bgColor: string;
  borderColor: string;
}

export const channelStats: ChannelStat[] = [
  {
    id: 'twitch',
    platform: 'Twitch',
    handle: 'kynothan',
    url: 'https://www.twitch.tv/kynothan',
    icon: '/img/twitch.svg',
    count: 1240,
    isLive: false,
    color: 'text-[#9146FF]',
    bgColor: 'bg-[#9146FF]/10',
    borderColor: 'border-[#9146FF]/20',
  },
  {
    id: 'instagram',
    platform: 'Instagram',
    handle: 'kynothanvod',
    url: 'https://www.instagram.com/Kynothanvod/',
    icon: '/img/instagram.svg',
    count: 870,
    isLive: false,
    color: 'text-[#E1306C]',
    bgColor: 'bg-[#E1306C]/10',
    borderColor: 'border-[#E1306C]/20',
  },
  {
    id: 'tiktok',
    platform: 'TikTok',
    handle: 'kynothanvod',
    url: 'https://www.tiktok.com/@kynothanvod',
    icon: '/img/tiktok.svg',
    count: 2100,
    isLive: false,
    color: 'text-slate-900 dark:text-slate-100',
    bgColor: 'bg-slate-100 dark:bg-white/10',
    borderColor: 'border-slate-200 dark:border-white/20',
  },
];

/** Format a raw number to a short human-readable string (1200 → 1.2K) */
export const formatCount = (n: number): string => {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
  return n.toString();
};
